import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const ColumnVertical1 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M15.8333 2.5C16.7538 2.5 17.5 3.23597 17.5 4.14384L17.5 15.8562C17.5 16.764 16.7538 17.5 15.8333 17.5H13.3333C12.4129 17.5 11.6667 16.764 11.6667 15.8562L11.6667 4.14384C11.6667 3.23597 12.4129 2.5 13.3333 2.5L15.8333 2.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.16667 2.5C3.24619 2.5 2.5 3.23597 2.5 4.14384L2.5 15.8562C2.5 16.764 3.24619 17.5 4.16667 17.5H6.66667C7.58714 17.5 8.33333 16.764 8.33333 15.8562L8.33333 4.14384C8.33333 3.23597 7.58714 2.5 6.66667 2.5L4.16667 2.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default ColumnVertical1
